import React from 'react';
import '../styles/AboutMe.css'; // Separate CSS for this window

const AboutMe = ({ isDarkMode }) => {
    const containerClass = `about-me-container ${
        isDarkMode ? 'about-me-container-dark' : 'about-me-container-light'
    }`;

    const dividerClass = `about-me-division ${
        isDarkMode ? 'about-me-division-dark' : 'about-me-division-light'
    }`;

    return (
        <div className={containerClass}>
            <div className="about-me-heading">
                <h1>
                    Hi There, <br />
                    I’m <span>Celina</span> <span className='wave'>👋</span>
                </h1>
            </div>

            <div className={dividerClass} />

            <div className="about-me-content">
                <p>
                    A graduate in <span>Computer Science</span> @ UNSW. I’m always looking for ways to blend my creativity with technical skills! 💻
                    <br />
                    <br />
                    As I pursue my goal of becoming a <span>full-stack engineer</span>, I’m excited to contribute to projects that bridge the gap between technical functionality and UX. 🌟
                </p>
            </div>
        </div>
    );
};

export default AboutMe;
